export const mixpanelConfig = {
  token: process.env.MIXPANEL_TOKEN || "development",
  debug: process.env.NODE_ENV === "development",
  api_host: process.env.MIXPANEL_API_HOST || "https://api-eu.mixpanel.com",
  track_pageview: false,
  persistence: "cookie" as const,
  cross_subdomain_cookie: false,
  secure_cookie: true,

  ip: false,

  property_blacklist: ["id_token"],
};
